export const EMAIL_WELCOME_SUCCESS = "EMAIL_WELCOME_SUCCESS";
export const MAIL_WELCOME_FAILED = "MAIL_WELCOME_FAILED";